import { defineComponent as _defineComponent } from 'vue';
import { SelectPortal, SelectContent, SelectViewport } from 'reka-ui';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SelectContent',
    props: {
        sideOffset: { type: Number, required: false, default: 4 }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const __returned__ = { get SelectPortal() { return SelectPortal; }, get SelectContent() { return SelectContent; }, get SelectViewport() { return SelectViewport; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
